module.exports = __webpack_public_path__ + "static/media/low-3.a0012230.png";